<template>
    <div class="page-titles py-2">
        <h3 class="mb-0">{{ title }}</h3>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, default: "" },
    },
};
</script>

<style>
h3 {
    color: #009efb;
    line-height: 30px !important;
    font-size: 21px !important;
    font-weight: 400 !important;
    font-family: "Rubik", sans-serif;
}
</style>
